import { createContext } from 'react';

const CategoriesStateContext = createContext([] as any[]);
export default CategoriesStateContext;
